import { useAppSelector } from '@redux/hooks';
import { guestCountFromRange } from '../../../../../../../lib/storefront-pricing/utils/guestCountToRange';

export const useEstimateFormProfile = () => {
	const profileGuestCount = useAppSelector((state) =>
		guestCountFromRange(state.membership.member?.number_of_guests),
	);
	const profileWeddingDate = useAppSelector(
		(state) => state.membership.member?.wedding_date || '',
	);
	const profileFirstName = useAppSelector(
		(state) => state.membership.member?.first_name || '',
	);
	const profileLastName = useAppSelector(
		(state) => state.membership.member?.last_name || '',
	);
	const profileEmail = useAppSelector(
		(state) => state.membership.member?.email || '',
	);
	const vendorName = useAppSelector((state) => state.vendor.vendor?.name || '');
	const vendorId = useAppSelector((state) => state.vendor.vendor?.id);
	const conversations = useAppSelector(
		(state) => state.messagedVendors.conversations,
	);
	const hasContactedVendor = Boolean(vendorId && conversations[vendorId]);

	return {
		profileGuestCount,
		profileWeddingDate,
		profileFirstName,
		profileLastName,
		profileEmail,
		vendorName,
		vendorId,
		hasContactedVendor,
	};
};
